import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingArgument } from './components/ClosingArgument';
import { EverythingIncluded } from './components/EverythingIncluded';
import { VisualSection } from './components/VisualSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { ProductGallery } from './components/ProductGallery';
import { SolutionReveal } from './components/SolutionReveal';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { VolumesSection } from './components/VolumesSection';
import { META_PIXEL_ID } from './utils/tracking';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
interface AppProps {
  showTestimonials?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showTestimonials = true,
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-white text-slate-800" data-id="element-0" data-mp="3gl4pnbwh7qhe">
      <main data-id="element-1" data-mp="3gja8m8obsiil">
        <Hero data-id="element-2" data-mp="3bmbe3p0r29jv" />
        {showTestimonials && <TestimonialsStrip data-id="element-3" data-mp="3bn30qacdcwy0" />}
        <ProductGallery data-id="element-4" data-mp="3bo4mb8r0h1tz" />
        <PainPoints data-id="element-5" data-mp="3bkgrm69ty9do" />
        <SolutionReveal data-id="element-6" data-mp="3qbpo8zc5gv0b" />
        <VisualSection data-id="element-7" data-mp="3qc94mbm5jbc8" />
        <VolumesSection data-id="element-8" data-mp="3qcim1at4sa6b" />
        <BonusSection data-id="element-9" data-mp="3lkheg26wr7mm" />
        <PricingSection data-id="element-10" data-mp="3ljxu6etsc75f" />
        <ClosingArgument data-id="element-11" data-mp="3ljpigq9ef7vt" />
        <Guarantee data-id="element-12" data-mp="3lieeapc1jy46" />
        <FAQ data-id="element-13" data-mp="2xuwv3i6ue8ct" />
        <FinalCTA data-id="element-14" data-mp="2xumznf3138zq" />
        <EverythingIncluded data-id="element-15" data-mp="2xu3n6dw5dct3" />
      </main>
      <Footer data-id="element-16" data-mp="2xssh27f8bsyt" />
      {showPurchaseNotifications && <PurchaseNotification data-id="element-17" data-mp="2swbq75gnb0i1" />}
      <noscript data-id="element-18" data-mp="2svahh7n3qq3h">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-19" data-mp="2stpm5fsyr34k" />
      </noscript>
    </div>;
}